"use client";

import { c as _c } from "react/compiler-runtime";
import { ArrowRightIcon } from "@heroicons/react/24/solid";
import { Button, Card, CardContent, CardFooter, CardHeader, cn } from "@saridana-core/react-ui-kit";
import { ArticleCategory, TArticle } from "@shared/types";
import { formatDate } from "@shared/utils";
import Image from "next/image";
import Link from "next/link";
import { ButtonLink } from "../button-link";
type Props = {
  article: TArticle;
  category: ArticleCategory;
  buttonVariant?: "default" | "link";
  className?: string;
  imageClassName?: string;
};
export function ArticleCard(t0) {
  const $ = _c(30);
  const {
    article,
    category,
    className,
    buttonVariant: t1,
    imageClassName
  } = t0;
  const buttonVariant = t1 === undefined ? "default" : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cn("text-gray-950 border-0 shadow-none h-full flex flex-col justify-between", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== article?.image || $[3] !== imageClassName) {
    t3 = article?.image && article?.image.data && <CardHeader className="p-0 pb-6 md:pb-8"><Image src={article?.image?.data?.attributes?.url || ""} width={article?.image?.data?.attributes?.width || 416} height={article?.image?.data?.attributes?.height || 240} alt={article?.image?.data?.attributes?.alternativeText || article?.image?.data?.attributes?.name || ""} className={cn("h-[206px] md:h-[142px] lg:h-[240px] w-full object-cover object-center rounded-2xl border border-gray-50 bg-gray-50", imageClassName)} /></CardHeader>;
    $[2] = article?.image;
    $[3] = imageClassName;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = article?.publishedDate;
  let t5;
  if ($[5] !== t4) {
    t5 = formatDate(t4);
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <div className="text-base font-medium text-gray-600">{t5}</div>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = "/" + (category || "news") + "/" + article?.slug;
  const t8 = article?.shortTitle;
  let t9;
  if ($[9] !== t7 || $[10] !== t8) {
    t9 = <h4 className="mt-2 font-bold text-[28px] line-clamp-3 sm:line-clamp-2 lg:line-clamp-3"><Link href={t7} className="hover:text-primary-600">{t8}</Link></h4>;
    $[9] = t7;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== article?.fullTitle) {
    t10 = article?.fullTitle && <p className="mt-4 sm:mt-5 font-normal text-lg text-gray-700 line-clamp-3">{article?.fullTitle}</p>;
    $[12] = article?.fullTitle;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t6 || $[16] !== t9) {
    t11 = <CardContent className="p-0">{t6}{t9}{t10}</CardContent>;
    $[14] = t10;
    $[15] = t6;
    $[16] = t9;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11 || $[19] !== t3) {
    t12 = <div>{t3}{t11}</div>;
    $[18] = t11;
    $[19] = t3;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== article?.readMoreButtonText || $[22] !== article?.slug || $[23] !== buttonVariant || $[24] !== category) {
    t13 = article?.readMoreButtonText && category && <CardFooter className="px-0 pb-0 pt-8 sm:pt-9 lg:pt-10 mt-auto">{buttonVariant === "default" ? <ButtonLink href={"/" + category + "/" + article?.slug} target="_self" variant="primary" size="md" text={article?.readMoreButtonText} /> : <Button asChild={true} variant="link" className="p-0 m-0 h-auto text-primary-600 font-semibold text-xl"><Link href={"/" + category + "/" + article?.slug} target="_self">{article?.readMoreButtonText}<ArrowRightIcon className="size-6" /></Link></Button>}</CardFooter>;
    $[21] = article?.readMoreButtonText;
    $[22] = article?.slug;
    $[23] = buttonVariant;
    $[24] = category;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t12 || $[27] !== t13 || $[28] !== t2) {
    t14 = <Card className={t2}>{t12}{t13}</Card>;
    $[26] = t12;
    $[27] = t13;
    $[28] = t2;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  return t14;
}